/**
 * Os avisos da equipe que conduz o exame (E150.F1 — GUS-150, ADR-0102 §4): o que o cliente
 * registrou na conversa dos casos. O contrato é o mesmo do portal (`lib/portal/avisos.ts`); muda a
 * rota, que é da classe equipe.
 */
import type { AxiosInstance } from 'axios';

import type { AvisosData, AvisoTipo } from '@/lib/portal/avisos';

export async function getAvisosDaEquipe(client: AxiosInstance): Promise<AvisosData> {
  const { data } = await client.get<AvisosData>('/avisos');
  return data;
}

export async function marcarAvisoVistoDaEquipe(
  client: AxiosInstance,
  aviso: { tipo: AvisoTipo; objeto_id: string },
): Promise<AvisosData> {
  const { data } = await client.post<AvisosData>('/avisos/visto', aviso);
  return data;
}
